import { Component } from '@angular/core';
import { Guide, GUIDES } from './guides';

/** /guides hub: every published number plate guide. */
@Component({
  selector: 'pla-article-landing',
  templateUrl: './article-landing.component.html',
  styleUrls: ['./article-landing.component.scss']
})
export class ArticleLandingComponent {
  public readonly guides: Guide[] = GUIDES;
}
